import type {
  ArchetypeConfig,
  DynamicsConfig,
  KineticCoreConfig,
} from "../types/game-config";
import type { SpaceConfig } from "../types/space";

export const DEFAULT_SPACE_CONFIG: SpaceConfig = {
  cols: 9,
  rows: 10,
  boundaryPadding: 0.5,
} as const;

export const DEFAULT_DYNAMICS_CONFIG: DynamicsConfig = {
  timeStep: 1 / 60,
  frictionCoefficient: 3.0,
  velocityThreshold: 0.01,
  minImpulseMagnitude: 0.1,
  restitutionCoefficient: 0.8,
  maxSimulationSteps: 600,
} as const;

export const DEFAULT_ARCHETYPE_CONFIGS: ReadonlyArray<ArchetypeConfig> = [
  { archetype: "HEAVY", radius: 0.45, mass: 1.5 },
  { archetype: "MEDIUM", radius: 0.38, mass: 1.2 },
  { archetype: "LIGHT", radius: 0.3, mass: 0.8 },
] as const;

export const DEFAULT_CONFIG: KineticCoreConfig = {
  space: DEFAULT_SPACE_CONFIG,
  dynamics: DEFAULT_DYNAMICS_CONFIG,
  archetypes: DEFAULT_ARCHETYPE_CONFIGS,
  maxTurns: 50,
} as const;
